import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./lib/i18n/config";

import { routeTree } from "./routeTree.gen";
import { getCookie } from "./lib/utils";
import { api } from "./lib/api";
import { identify } from "./lib/analytics";
import { useAppStore } from "./lib/store";

Sentry.init({
  dsn: "https://b69603218cfb403ea7a1e9c6dcf9c01f@errors.wikiparty.org/1",
  tracesSampleRate: 0.1,
  enabled: !import.meta.env.DEV,
});

async function initAuth() {
  await api.ensureAuthenticated();
  const userId = getCookie("id");
  const userName = getCookie("user");
  if (userId) {
    useAppStore.setState({ id: userId, name: userName || userId });
    identify({ id: userId });
  }
}

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  initAuth();

  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
